if (!customElements.get('quick-view-modal-opener')) {
    customElements.define('quick-view-modal-opener', class QuickViewModalOpener extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.onButtonClickHandler = this.onButtonClick.bind(this);
        if(this.button) {
          this.button.addEventListener('click', this.onButtonClickHandler);
        }
      }
  
      onButtonClick() {
        if(!window.hasQuickViewModal) {
          window.hasQuickViewModal = true;
          this.button.setAttribute('aria-disabled', true);
          this.button.classList.add('loading');
          this.button.querySelector('.loading-overlay__spinner').classList.remove('hidden');
          fetch(`${Shopify.routes.root}?section_id=quick-view-modal`)
            .then((response) => response.text())
            .then((responseText) => {
              document.body.appendChild(getDomHtmlFromText(responseText, '.quick-view-modal'));
              const modal = document.querySelector(this.dataset.modal);
              if (modal) modal.show(this.button);
              HTMLUpdateUtility.reinjectsScripts(document.getElementById('QuickView-Modal'));
            });
        } else {
          const modal = document.querySelector(this.dataset.modal);
          modal.modalContent.innerHTML = '';
          if (modal) modal.show(this.button);
        }
      }

      disconnectedCallback() {
        if(this.button) {
          this.button.removeEventListener('click', this.onButtonClickHandler);
        }
      }
    });
  }
  if (!customElements.get('quick-view-modal')) {
    customElements.define('quick-view-modal', class QuickViewModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickViewInfo-"]');
        this.moved = true;
      }
  
      hide(preventFocus = false) {
        this.classList.remove('open-content');
        setTimeout(() => {
          if (preventFocus) this.openedBy = null;
          super.hide();
          setTimeout(() => {
            this.modalContent.innerHTML = '';
          }, 500);
        }, 300);
      }
  
      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        document.body.classList.add('overflow-hidden');
  
        let url = opener.dataset.productUrl;
        if(url.includes('?')) {
          url += '&';
        } else {
          url += '?';
        }
        // url += 'section_id=quick-view';
        url += 'view=quick-view';
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('product-info[id^="ProductQuickView-"]');
            this.productElement.classList.remove('hidden');
            HTMLUpdateUtility.setInnerHTML(this.modalContent, this.productElement.outerHTML);

            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            function swymCallbackFn(swat){
              // your API calls go here
              document.addEventListener("swym:collections-loaded", function(){
                swat.initializeActionButtons("body");
              })
            }
            if(!window.SwymCallbacks){
              window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(swymCallbackFn);

            document.addEventListener('click', function(e) {
              const link = e.target.closest('#description_info');
              if (!link) return;

              e.preventDefault();
              e.stopImmediatePropagation(); // kill quickview interceptors
              window.location.href = link.href;
            });

            document.querySelectorAll('.after_pay_link').forEach(function (link) {
              link.addEventListener('click', function (e) {
                  e.preventDefault();

                  var modal = document.querySelector('div.afterpay-modal-overlay');
                  if (modal) {
                    modal.classList.toggle("show");
                  }
              });
            });

            document.addEventListener('click', function(e) {
              const link = e.target.closest('div.afterpay-modal-overlay .afterpay-close-button');
              if (!link) return;
              
              var modal = document.querySelector('div.afterpay-modal-overlay');
              modal.classList.toggle("show");
            });

            // Soldout count
            const interval1 = setInterval(() => {
              const optionContainer = document.querySelector('product-info  .soldcount-container');
              const targetEl = document.querySelector('product-info .product__title #label-soldcount');

              if (optionContainer && targetEl) {
                clearInterval(interval1);
                targetEl.insertAdjacentHTML(
                  'beforeend',
                  optionContainer.innerHTML
                );
              }
            }, 200);

            window?.Shopify?.PaymentButton?.init();
            window?.ProductModel?.loadShopifyXR();
  
            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.waitForKlarnaShadow();
            this.preventVariantURLSwitching();
            super.show(opener);
            setTimeout(() => {
              this.classList.add('open-content');
            }, 300);
            if(window.recentlyViewedStrings) {
              BtRecentlyViewedUtil.addProduct(this.productElement.dataset.productId, this.productElement.dataset.productUrl, this.productElement.dataset.productImage);
            }
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }
  
      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if(variantPicker) {
          variantPicker.setAttribute('data-update-url', 'false');
        }
      }
  
      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
  
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
      }
      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;
        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;
        let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }
        mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
      }

      waitForKlarnaShadow() {

        const interval = setInterval(() => {
          const priceEl = this.modalContent.querySelector(
          '.price__regular .price-item--regular, .price-item--sale'
        );

          if (!priceEl) return;

          // Remove currency symbols & commas
          const priceText = priceEl.textContent.replace(/[^\d.]/g, '');
          const price = parseFloat(priceText);

          let installment = (price / 4).toFixed(2);

          const host = document.querySelector('klarna-placement');

          if (host && host.shadowRoot) {
            clearInterval(interval);

            // Avoid injecting duplicate styles
            if (!host.shadowRoot.querySelector('#klarna-custom-style')) {
              const style = document.createElement('style');
              style.id = 'klarna-custom-style';
              style.innerHTML = `
                div[part="osm-container"]{
                  background: transparent;
                  padding: 0;
                  font-size: 12px;
                  font-family: Roboto, sans-serif;
                  line-height: 1;
                  align-items: flex-start;
                  flex-direction: column;
                }
                div[part="osm-container"] .badge-container svg{
                      width:45px;
                      height: 16px;
                }
                div[part="osm-container"] .text-wrapper{
                    margin-top: 9px;
                    display: flex;
                    align-items: center;
                  }
                .text-wrapper p[part="osm-message"] {
                  font-size: 0;
                }

                .text-wrapper p[part="osm-message"] button {
                  font-size: 0; 
                }
                .text-wrapper p[part="osm-message"] button:after{
                  background-size: 12px;
                }
                button.link {
                  display: flex;
                  align-items: center;
                  gap: 6px; /* space between icon & text */
                }

                /* SVG icon */
                button.link::after {
                  content: '';
                  width: 12px;
                  height: 12px;
                  background-image:url("https://cdn.shopify.com/s/files/1/0382/3940/4165/files/info.svg?v=1767598024");
                  }
              `;
              host.shadowRoot.appendChild(style);
            }

            if (!host.shadowRoot.querySelector('#klarna-custom-script')) {
              const jsScript = document.createElement('script');
              jsScript.id = 'klarna-custom-script';
              jsScript.innerHTML = `
                console.log('Klarna ready script');
                
                (function () {
                  const installment = "${installment}";
                  const strg = '<p class="custom-klarna-text">4 x NZ $'+ installment + '</p>';
                  console.log(strg);
                  
                  const host = document.querySelector('klarna-placement');
                  const shadoRoot = host.shadowRoot; 

                  const wrapper = shadoRoot.querySelector('.container .text-wrapper');

                  if (wrapper && !shadoRoot.querySelector('#klarna-extra-html')) {
                    const div = document.createElement('div');
                    div.id = 'klarna-extra-html';
                    div.innerHTML = strg;

                    wrapper.prepend(div);
                  }
                })();
              `;
              host.shadowRoot.appendChild(jsScript);
            } 

          }
        }, 200);

        // safety stop after 10 seconds
        // setTimeout(() => clearInterval(interval), 10000);
      }

    });
  }
  